import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=701ab5aa"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports